import { Button, Checkbox, Col, Divider, Flex, Form, Input, Row } from "antd";
import React, { useEffect } from "react";
import LOGO from "../../../assets/images/logo.svg";
import {
  AppleIcon,
  GoogleIcon,
  MicrosoftIcon,
  PassKeyIcon,
} from "../../../components/Icons";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFinish = () => {
    localStorage.setItem("token", "hello-world");
    navigate("/");
  };

  return (
    <div className="auth-container">
      <div className="main-row">
        <div className="img-col">
          <img
            src={require("../../../assets/images/auth-side-img.jpg")}
            alt=""
          />
        </div>
        <div className="content-col">
          <Flex vertical justify="center" className="content-parent">
            <img src={LOGO} className="logo" alt="logo" />
            <h1 className="heading">Login</h1>
            <h3 className="sub-heading">
              Welcome back. Stay on track with confidence.
            </h3>
            <Form
              form={form}
              layout="vertical"
              className="form"
              onFinish={handleFinish}
              initialValues={{
                email: "example@example.com",
              }}
            >
              <Form.Item label="Email Address" name="email">
                <Input type="email" placeholder="Enter your email address" />
              </Form.Item>
              <Form.Item name="agree" valuePropName="checked" label={null}>
                <Checkbox>Remember me</Checkbox>
              </Form.Item>
              <Form.Item label={null}>
                <Button type="primary" htmlType="submit" className="submit-btn">
                  Continue
                </Button>
              </Form.Item>
            </Form>
            <Divider>or</Divider>
            <Button className="social-login-btn" variant="outlined">
              <GoogleIcon />
              Continue with Google
            </Button>
            <Button className="social-login-btn" variant="outlined">
              <AppleIcon />
              Continue with Apple
            </Button>
            <Button className="social-login-btn" variant="outlined">
              <MicrosoftIcon />
              Continue with Microsoft
            </Button>
            <Button className="social-login-btn" variant="outlined">
              <PassKeyIcon />
              Login with passkey
            </Button>

            <p className="already-account-text">
              Need an account?{" "}
              <Button
                htmlType="submit"
                type="link"
                onClick={() => navigate("/signup")}
              >
                Sign up
              </Button>
            </p>
          </Flex>
        </div>
      </div>
    </div>
  );
};

export default Login;
